import { Flex, Grid, GridItem, Icon, Text, Tooltip } from '@chakra-ui/react'
import { ObservacoesGerais } from './components/Modais/ObservacoesGerais'
import { RetornarEm } from './components/Modais/RetornarEm'
import { DadosEntrega } from './components/Modais/DadosEntrega'
import { ObservacoesCliente } from './components/Modais/ObservacoesCliente'
import { HistoricoProposta } from './components/Modais/HistoricoProposta'
import { TotalPedidos } from './components/Modais/TotalPedidos'
import { HistoricoPagamento } from './components/Modais/HistoricoPagamento'
import { TotalOrcamentos } from './components/Modais/TotalOrcamentos'
import { ModalContato } from './components/Modais/ModalContato'
import { ModalCliente } from './components/Modais/ModalCliente'
import { FcCustomerSupport } from 'react-icons/fc'

import { FaRegStar, FaWhatsapp } from 'react-icons/fa'
import { BoxBorder } from './components/BoxBorder'
import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai'
import { FiSmartphone } from 'react-icons/fi'
import { useModalCallPhone } from '../../../contexts/CallPhoneContext'

import { SelectsHeader } from './SelectsHeader'
import { useOrcamentoPedido } from '../../../contexts/OrcamentoPedidoProvider'
import { Skeleton } from './styles'
import { format } from 'date-fns'
import { DataSaida } from './components/DataSaida'
import { Transportadora } from './Transportadora'
import { DetalhesDaProposta } from './components/Modais/DetalhesDaProposta'
import { CgWebsite } from 'react-icons/cg'
import { AgendamentoRetornoCliente } from './components/Modais/AgendamentoRetornoCliente'
import { user } from '../../../helpers/user'

export function Header({ infoProposta, itens }) {
  const { openCallPhone } = useModalCallPhone()
  const { isLoading, pedidoBloqueado } = useOrcamentoPedido()

  if (isLoading) {
    return <Skeleton width="1335px" height="155px" />
  }

  return (
    <BoxBorder>
      <Flex alignItems="center" justifyContent="space-between" textTransform="uppercase">
        <Flex color="#378BBF" alignItems="center" gap={2}>
          <Icon as={FaRegStar} fontSize="20px" />
          <Text fontWeight="bold">Nº Proposta:</Text> <Text color="#000000">{infoProposta.numero_pedido}</Text>
        </Flex>
        {infoProposta.data_abertura ? format(new Date(infoProposta.data_abertura), 'dd/MM/yyyy HH:mm') : ''}

        <SelectsHeader infoProposta={infoProposta} itens={itens} />
      </Flex>
      <Flex color="#378BBF" alignItems="center" gap={2}>
        <Icon as={FcCustomerSupport} fontSize="20px" />
        <Text fontWeight="bold">Vendedor:</Text> <Text color="#000000">{infoProposta?.nome_vendedor}</Text>
      </Flex>

      <Grid gridTemplateColumns={'minmax(500px, 1fr) 1fr 379px'} minH="90px" mt={5}>
        <GridItem borderRight="1px solid #cecece" pr="12px" display="flex" flexDir="column" justifyContent="space-between" py={2}>
          <Flex justifyContent="space-between" alignItems="center" gap={2} cursor="pointer">
            <ModalCliente infoProposta={infoProposta} />
            {infoProposta?.bloqueia_estado && (
              <Tooltip label="Cliente de Tocantins tem DIFAL">
                <Text color="red" fontSize="12px" fontWeight="bold">
                  Cliente de Tocantins tem DIFAL
                </Text>
              </Tooltip>
            )}
          </Flex>
          <ModalContato infoProposta={infoProposta} />
          <Flex alignItems="center" gap={2} cursor="pointer" pointerEvents={pedidoBloqueado ? 'none' : 'auto'}>
            <Icon as={CgWebsite} color="#378BBF" fontSize="20px" />{' '}
            <Tooltip
              label={
                <Text>
                  Contato do site: {infoProposta?.contato_site?.nome_contato || 'Sem contato'} |{' '}
                  {infoProposta?.contato_site?.email_contato || 'Sem email'} | {infoProposta?.contato_site?.numero_contato || 'Sem celular'}
                </Text>
              }
            >
              <Text maxW="full" isTruncated>
                Contato do site: {infoProposta?.contato_site?.nome_contato || 'Sem contato'} |{' '}
                {infoProposta?.contato_site?.email_contato || 'Sem email'} | {infoProposta?.contato_site?.numero_contato || 'Sem celular'}
              </Text>
            </Tooltip>
          </Flex>
          <Flex justifyContent="space-between" alignItems="center">
            <Flex alignItems="center" gap={2} pointerEvents={pedidoBloqueado ? 'none' : 'auto'}>
              <Icon as={AiOutlineMail} color="#378BBF" fontSize="20px" />{' '}
              <Tooltip label={infoProposta.email_parceiro}>
                <Text maxW="220px" w="full" isTruncated>
                  {infoProposta.email_parceiro || 'Sem email'}
                </Text>
              </Tooltip>
            </Flex>
            <Flex
              alignItems="center"
              pointerEvents={pedidoBloqueado ? 'none' : 'auto'}
              gap={2}
              onClick={() => openCallPhone(infoProposta.cliente.celular)}
              cursor="pointer"
            >
              <Icon as={FiSmartphone} color="#378BBF" fontSize="20px" /> {infoProposta.cliente.celular || 'Sem celular'}
            </Flex>
            <Flex alignItems="center" gap={2} onClick={() => openCallPhone(infoProposta.cliente.telefone)} cursor="pointer">
              <Icon as={AiOutlinePhone} color="#378BBF" fontSize="20px" /> {infoProposta.cliente.telefone || 'Sem telefone'}
            </Flex>
            <Tooltip label="Abrir Chat Guru">
              <Text as="a" href={infoProposta.link_zap} target="_blank">
                <FaWhatsapp color={infoProposta.link_zap ? '#25D366' : '#ff0000'} fontSize="20px" cursor="pointer" />
              </Text>
            </Tooltip>
          </Flex>
          {infoProposta?.observacao_adm && <Text>{infoProposta.observacao_adm}</Text>}
        </GridItem>
        <GridItem
          pointerEvents={pedidoBloqueado ? 'none' : 'auto'}
          borderRight="1px solid #cecece"
          display="grid"
          gridTemplateColumns="1fr 1fr"
          px="12px"
          //gap na coluna
          columnGap="17px"
          py={2}
          rowGap={2}
          justifyContent="space-between"
          placeContent={'end'}
        >
          <GridItem colSpan={2}>
            <DetalhesDaProposta infoProposta={infoProposta} />
          </GridItem>
          <TotalOrcamentos totalOrcamentos={infoProposta?.total_orcamento} infoProposta={infoProposta} />
          <HistoricoPagamento listHistoryPayment={infoProposta?.historico_pagamento} />
          <TotalPedidos infoProposta={infoProposta} />

          <HistoricoProposta infoProposta={infoProposta} />
        </GridItem>

        <GridItem
          display="grid"
          gridTemplateColumns="1fr 1fr"
          px="12px"
          py={2}
          columnGap="12px"
          placeContent={'end'}
          pointerEvents={pedidoBloqueado ? 'none' : 'auto'}
          rowGap={2}
        >
          <GridItem colSpan="2">
            <Flex flexDir="column" gap={2} alignItems="flex-start">
              <DataSaida />
              {infoProposta?.transportadora?.nome_transportadora && (
                <Transportadora transportadora={infoProposta?.transportadora} numeroNota={infoProposta.num_proposta} />
              )}
            </Flex>
          </GridItem>
          <Flex justifyContent="space-between" maxW="180px" w="full" alignItems="flex-end">
            <Text>Obs Cliente </Text>
            <ObservacoesCliente obs={infoProposta?.cliente.observacao_cliente} infoProposta={infoProposta} />
          </Flex>
          <Flex justifyContent="space-between" maxW="180px" w="full" alignItems="center">
            <Text>Dados de Entrega</Text>
            <DadosEntrega dadosEntrega={infoProposta} infoProposta={infoProposta} />
          </Flex>
          <Flex justifyContent="space-between" maxW="180px" w="full" alignItems="center" pointerEvents={'auto'}>
            <Text>
              Retornar em: <strong>{infoProposta.cliente.data_retorno}</strong>
            </Text>
            <RetornarEm
              dadosRetorno={infoProposta?.dados_retorno}
              infoProposta={infoProposta}
              numeroNota={infoProposta?.num_proposta}
              pedidoBloqueado={pedidoBloqueado}
            />
          </Flex>
          <Flex justifyContent="space-between" maxW="180px" w="full" alignItems="center">
            <Text>Obs Gerais</Text>
            <ObservacoesGerais obs={infoProposta?.observacoes_gerais} infoProposta={infoProposta} />
          </Flex>
        </GridItem>
      </Grid>
    </BoxBorder>
  )
}
